module.exports = __webpack_public_path__ + "media/images/favicon-285c048552d08b7114fcaf924e4fb457.svg";